export const CREATE_ROOM_SUCCESS = 'CREATE_ROOM_SUCCESS';

export const DELETE_ROOM_SUCCESS = 'DELETE_ROOM_SUCCESS';

export const UPDATE_ROOM_SUCCESS = 'UPDATE_ROOM_SUCCESS';

export const FILTER_ROOMS = 'FILTER_ROOMS';
export const LOAD_ROOMS_SUCCESS = 'LOAD_ROOMS_SUCCESS';
export const UNLOAD_ROOMS_SUCCESS = 'UNLOAD_ROOMS_SUCCESS';

export const SELECT_BUILDING = 'SELECT_BUILDING'


// WEBPACK FOOTER //
// ./src/core/room-browse/action-types.js